var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCoupon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8h-.8a.8.8 0 0 0 .8.8V8zm0 3v-.8a.8.8 0 0 0-.8.8H3zm.8-5A1.2 1.2 0 0 1 5 4.8V3.2A2.8 2.8 0 0 0 2.2 6h1.6zm0 2V6H2.2v2h1.6zm-.8.8c.287 0 .606.264.606.7h1.6c0-1.22-.94-2.3-2.206-2.3v1.6zm.606.7c0 .436-.319.7-.606.7v1.6c1.266 0 2.206-1.08 2.206-2.3h-1.6zM3.8 13v-2H2.2v2h1.6zM5 14.2A1.2 1.2 0 0 1 3.8 13H2.2A2.8 2.8 0 0 0 5 15.8v-1.6zm10 0H5v1.6h10v-1.6zm1.2-1.2a1.2 1.2 0 0 1-1.2 1.2v1.6a2.8 2.8 0 0 0 2.8-2.8h-1.6zm0-7v7h1.6V6h-1.6zM15 4.8A1.2 1.2 0 0 1 16.2 6h1.6A2.8 2.8 0 0 0 15 3.2v1.6zm-10 0h10V3.2H5v1.6z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BDBDBD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.977 4.8v9.4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCoupon);
export default __webpack_public_path__ + "static/media/ic-coupon.d5e766c3411b6a16e9c73877640bcfb1.svg";
export { ForwardRef as ReactComponent };